import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Filter, IFilter } from "./Filter";
import { Dialog } from "primereact/dialog";
import { format, startOfMonth, endOfMonth } from "date-fns";


interface Iprops {
    toast: any,
    reload: boolean,
    reloadData: () => void,
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false } as { data: any[], count: number, loading: boolean });

    // dialogs
    const [soldDialog, setSoldDialog] = useState(false);
    const [renewDialog, setRenewDialog] = useState(false);
    const [expiredDialog, setExpiredDialog] = useState(false);
    const [deactivatedDialog, setDeactivatedDialog] = useState(false);
    const [deviceDialog, setDeviceDialog] = useState(false);
    const [deviceData, setDeviceData] = useState<any[]>([]);
    const [leadDialog, setLeadDialog] = useState(false);
    const [leadData, setLeadData] = useState<any[]>([]);
    const [leadLoading, setLeadLoading] = useState(false);
    const [renewHistoryData, setRenewHistoryData] = useState<any[]>([]);
    const [renewHistoryDialog, setRenewHistoryDialog] = useState(false);
    const [renewHistoryLoading, setRenewHistoryLoading] = useState(false);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });
    const [filter, setFilter] = useState<IFilter>({
        fromDate: startOfMonth(new Date()),
        toDate: new Date(),
        assigned_To: []
    });
    useEffect(() => {
        loadTableData();
    }, [filter, lazyParams, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const loadTableData = async () => {
        if ((filter.fromDate && !filter.toDate) || (!filter.fromDate && filter.toDate)) {
            props.toast.current.show({
                severity: "warn",
                summary: "Validation",
                detail: "From Date and To Date both are required",
                life: 3000
            });
            return;
        }
        const fromDate = filter.fromDate ? format(new Date(filter.fromDate), 'yyyy-MM-dd') : "";
        const toDate = filter.toDate ? format(new Date(filter.toDate), 'yyyy-MM-dd') : "";
        setTableData((prev: any) => ({ ...prev, loading: true }));
        const userQuery = filter.assigned_To?.length
            ? filter.assigned_To.map(id => `userId=${id}`).join("&")
            : "";
        const query = `lazyParams=${JSON.stringify(lazyParams)}&fromDate=${fromDate}&toDate=${toDate}${userQuery ? `&${userQuery}` : ""}`;
        const response = await Fetch("Device/sales-summary", "GET", null, query, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ data: data.result, count: data.count, loading: false });
        } else {
            setTableData((prev: any) => ({ ...prev, loading: false }));
        }
    };

    const loadLeadDetails = async (userId: number, type: string) => {
        const fromDate = filter.fromDate ? format(new Date(filter.fromDate), 'yyyy-MM-dd') : "";
        const toDate = filter.toDate ? format(new Date(filter.toDate), 'yyyy-MM-dd') : "";
        setLeadLoading(true);
        const query = `fromDate=${fromDate}&toDate=${toDate}&userId=${userId}&type=${type}${filter.assigned_To ? `&assigned_To=${filter.assigned_To}` : ""}`;
        const response = await Fetch("Device/sales-details", "GET", null, query, props.toast);
        if (response) {
            const data = await response.json();
            setLeadData(data);
            if (type === "sold") setSoldDialog(true);
            if (type === "renewed") setRenewDialog(true);
            if (type === "expired") setExpiredDialog(true);
            if (type === "deactivated") setDeactivatedDialog(true);
        }

        setLeadLoading(false);
    };

    const loadDevices = (leadId: number) => {
        const lead = leadData.find(x => x.leadId === leadId);
        if (lead) {
            setDeviceData(lead.devices || []);
        } else {
            setDeviceData([]);
        }
        setDeviceDialog(true);
    };
    const clickableBody = (field: string, type: string) => {
        return (rowData: any) => (
            <span
                style={{ cursor: "pointer", color: "#2563eb", fontWeight: 600 }}
                onClick={() => loadLeadDetails(rowData.userId, type)}
            >
                {rowData[field]}
            </span>
        );
    };
    const deviceButton = (rowData: any) => {
        return (
            <span
                style={{ cursor: "pointer", color: "#16a34a", fontWeight: 600 }}
                onClick={() => loadDevices(rowData.leadId)}
            >
                View Plan ({rowData.deviceCount})
            </span>
        );
    };

    const loadRenewHistory = async (customerDeviceId: number) => {
        setRenewHistoryData([]);
        setRenewHistoryLoading(true);
        setRenewHistoryDialog(true);
        const response = await Fetch(`Device/device-renew-history/${customerDeviceId}`, "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setRenewHistoryData(data);
        }
        setRenewHistoryLoading(false);
    };

    const renewHistoryButton = (rowData: any) => {
        return (
            <span
                style={{ cursor: "pointer", color: "#8b5cf6", fontWeight: 600 }}
                onClick={() => loadRenewHistory(rowData.id)}
            >
                View History
            </span>
        );
    };

    const calculateTotal = (field: string) => {
        let total = 0;
        if (tableData.data) {
            tableData.data.forEach((item: any) => {
                total += (item[field] || 0);
            });
        }
        return total;
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">

            <div className="flex gap-4 w-full">
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: "uppercase", letterSpacing: 1 }}>
                        Sales Report
                    </h4>
                </div>
            </div>
        </div>
    );


    return (
        <>

            <Filter
                header={<div>Filter</div>}
                loading={tableData.loading}
                filter={filter}
                setFilter={setFilter}
            />

            <DataTable
                value={tableData.data}
                loading={tableData.loading}
                stripedRows
                size="small"
                showGridlines
                responsiveLayout="scroll"
                scrollHeight="75vh"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
            >
                <Column header="S.No" body={(rowData, options) => options.rowIndex + 1} footer="TOTAL" />
                <Column field="userName" header="User Name" />
                <Column
                    field="sold"
                    header="Sold"
                    body={clickableBody("sold", "sold")}
                    footer={calculateTotal("sold")}
                />

                <Column
                    field="renewed"
                    header="Renewed"
                    body={clickableBody("renewed", "renewed")}
                    footer={calculateTotal("renewed")}
                />

                <Column
                    field="expired"
                    header="Expired"
                    body={clickableBody("expired", "expired")}
                    footer={calculateTotal("expired")}
                />

                <Column
                    field="deactivated"
                    header="Deactivated"
                    body={clickableBody("deactivated", "deactivated")}
                    footer={calculateTotal("deactivated")}
                />

            </DataTable>


            <Dialog
                header="Sold Leads"
                visible={soldDialog}
                style={{ width: "70vw" }}
                onHide={() => setSoldDialog(false)}
            >
                <DataTable
                    value={leadData}
                    loading={leadLoading}
                    stripedRows
                    size="small"
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                >
                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="customerName" header="Customer Name" />
                    {/* <Column field="date" header="Created At" /> */}
                    <Column field="date" header="Sold Date" body={(rowData) => format(new Date(rowData.date + "Z"), 'dd/MM/yyyy')} />
                    <Column
                        field="date"
                        header="Time"
                        body={(rowData) => format(new Date(rowData.date + "Z"), 'hh:mm a')}
                    />
                    <Column body={deviceButton} header="Devices" />

                </DataTable>

            </Dialog>


            {/* RENEWED */}
            <Dialog
                header="Renewed Leads"
                visible={renewDialog}
                style={{ width: "70vw" }}
                onHide={() => setRenewDialog(false)}
            >
                <DataTable value={leadData} loading={leadLoading} stripedRows size="small"
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                >
                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="deviceName" header="Device Name" />
                    <Column field="customername" header="Customer Name" />
                    {/* <Column field="renewDate" header="Renew Date" body={(rowData) => format(new Date(rowData.renewDate + "Z"), 'dd/MM/yyyy')} />
                    <Column
                        field="renewDate"
                        header="Renew Time"
                        body={(rowData) => format(new Date(rowData.renewDate + "Z"), 'hh:mm a')}
                    /> */}
                    <Column body={renewHistoryButton} header="History" />
                </DataTable>
            </Dialog>

            <Dialog
                header="Renew History"
                visible={renewHistoryDialog}
                style={{ width: "50vw" }}
                onHide={() => setRenewHistoryDialog(false)}
            >
                <DataTable value={renewHistoryData} loading={renewHistoryLoading} stripedRows size="small"
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                >
                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />

                    <Column field="planName" header="Plan Name" />
                    <Column field="expectedActivationDate" header="Expected Activation Date" body={(rowData) => rowData.expectedActivationDate ? format(new Date(rowData.expectedActivationDate), 'dd/MM/yyyy') : '-'} />
                    <Column field="renewDate" header="Renew Date" body={(rowData) => rowData.renewDate ? format(new Date(rowData.renewDate + "Z"), 'dd/MM/yyyy') : '-'} />
                    <Column field="renewDate" header="Renew Time" body={(rowData) => rowData.renewDate ? format(new Date(rowData.renewDate + "Z"), 'hh:mm a') : '-'} />
                </DataTable>
            </Dialog>

            {/* EXPIRED */}

            <Dialog
                header="Expired Leads"
                visible={expiredDialog}
                style={{ width: "70vw" }}
                onHide={() => setExpiredDialog(false)}
            >

                <DataTable value={leadData} loading={leadLoading} stripedRows size="small"
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                >

                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="deviceName" header="Device Name" />
                    <Column field="customername" header="Customer Name" />
                    <Column field="date" header="Expired Date" body={(rowData) => format(new Date(rowData.date + "Z"), 'dd/MM/yyyy')} />
                    <Column
                        field="date"
                        header=" Time"
                        body={(rowData) => format(new Date(rowData.date + "Z"), 'hh:mm a')}
                    />
                </DataTable>

            </Dialog>

            {/* DEACTIVATED */}

            <Dialog
                header="Deactivated Leads"
                visible={deactivatedDialog}
                style={{ width: "70vw" }}
                onHide={() => setDeactivatedDialog(false)}
            >

                <DataTable value={leadData} loading={leadLoading} stripedRows size="small"
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                >

                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="deviceName" header="Device Name" />
                    <Column field="customername" header="Customer Name" />
                    <Column field="date" header="Deactivate Date" body={(rowData) => format(new Date(rowData.date + "Z"), 'dd/MM/yyyy')} />
                    <Column
                        field="date"
                        header=" Time"
                        body={(rowData) => format(new Date(rowData.date + "Z"), 'hh:mm a')}
                    />
                </DataTable>

            </Dialog>


            {/* DEVICE DIALOG */}

            <Dialog
                header="Plans"
                visible={deviceDialog}
                style={{ width: "70vw" }}
                onHide={() => setDeviceDialog(false)}
            >

                <DataTable
                    value={deviceData}
                    stripedRows
                    size="small"
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                >
                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="deviceName" header="Device Name" />
                    <Column field="plan.planName" header="Plan Name" />
                    <Column field="plan.planDuration" header="Duration (Days)" />
                    <Column field="plan.planPrice" header="Plan Price" />
                    <Column field="deal_Price" header="Deal Price" />
                    <Column field="expectedActivationDate" header="Exp. Activation" body={(rowData) => rowData.expectedActivationDate ? format(new Date(rowData.expectedActivationDate), 'dd/MM/yyyy') : '-'} />
                </DataTable>
            </Dialog>



        </>
    );
};